export default "__VITE_ASSET__CGSZxkPL__"